export class Accent {
  private _totalOccurrence = 0;

  constructor(
    public id: number,
    public name: string,
    public color: string,
    public occurrence: number,
  ){
  }

  set totalOccurrence(total: number) {
    this._totalOccurrence = total;
  }

  get totalOccurrence(): number {
    return this._totalOccurrence;
  }
}
